import {Alert, DatePicker, Form, Input, Select} from "antd";
import * as React from "react";
import moment from "moment";
import {DATE_DISPLAY_FORMAT} from "./DataSource";
import TextArea from "antd/lib/input/TextArea";

const {Option} = Select;

export default class AntdFormItemFactory {
    public getFormItem(field: any, data: any = null, type: String | null = null, options? : any) {
        type = type ? type : field.type;
        let method = "getFormItem_" + type;

        if (!this[method]) {
            return <Alert message={type + " is unsupported!"} type="error"/>
        }

        return this[method](field, data, options);
    }

    getFormItem_richtext(field: any, data: any = null) {
        return <Form.Item
            label={field.name}
            name={field.identifier}
            required={field.required}        
            tooltip={field.description}
        >
            <TextArea
                defaultValue={data && data[field.identifier] !== undefined ? data[field.identifier] : field.default_value}
            />
        </Form.Item>
    }


    getFormItem_text(field: any, data: any = null) {
        return <Form.Item
            label={field.name}
            name={field.identifier}
            required={field.required}
            tooltip={field.description}
        >
            <Input
                defaultValue={data && data[field.identifier] !== undefined ? data[field.identifier] : field.default_value}
                maxLength={field.parameters && field.parameters.max_length ? field.parameters.max_length : -1}
            />
        </Form.Item>
    }

    getFormItem_datetime(field: any, data: any = null) {
        let defaultValue: any = null;

        if (data && data[field.identifier] !== undefined) {
            defaultValue = moment(data[field.identifier]);
        } else if (field.default_value) {
            defaultValue = moment(field.default_value);
        }

        return <Form.Item
            label={field.name}
            name={field.identifier}
            required={field.required}
            tooltip={field.description}
        >
            <DatePicker
                defaultValue={defaultValue}
                format={DATE_DISPLAY_FORMAT}
            />
        </Form.Item>
    }

    getFormItem_select(field: any, data: any = null, options: any) {
        return <Form.Item
            label={field.name}
            name={field.identifier}
            required={field.required}
            tooltip={field.description}
        >
            <Select
                defaultValue={field.value ?? field.default_value}
            >
                {options.map((option, index) => <Option value={option.value} key={index+1}>{option.name}</Option>)}
            </Select>
        </Form.Item>
    }
}